import { iterableEmailCaptured } from "@utils/iterableSubmit";
import {
  SignUpStepCompleted,
  UseSignUpFormActionsType,
  UseSignUpFormStateType,
} from "../SignUpFormTypes/signUpFormTypes";
import { trialSignupEmailStepCompleted } from "@utils/segment-events";
import { segmentTrack } from "@utils/segment/segment-track";

export function signUpStepCompleted({ fields, step }: SignUpStepCompleted) {
  const trialSignupStepCompleted = (
    fields?: (string | undefined | null)[],
    step?: number
  ) => {
    segmentTrack("Trial Sign Up Step Completed", {
      fields,
      step: `step ${step} completed`,
      initiator: "User",
      object: "Trial Sign Up Step",
      action: "Completed",
      source_application: "Marketing",
    });
  };
  const fieldsNames = fields?.map(item => {
    if (item?.field === "questions") {
      const questionAttribute = item?.questionAttributes;
      return questionAttribute?.questionName;
    }

    return item.field;
  });

  trialSignupStepCompleted(fieldsNames, step);
}

export const signUpEmailStepCompleted = (
  state: UseSignUpFormStateType & UseSignUpFormActionsType,
  ctaText: string,
  email: string
) => {
  if (state.steps[state.currentStep].fields.some(f => f.field === "email")) {
    trialSignupEmailStepCompleted(ctaText, email);
    iterableEmailCaptured(email);
  }
};
